import { OutfitData } from "../../../types/Profile";
import OutfitCard from "../OutfitCard";

interface RecentTabProps {
  outfits: OutfitData[];
  favouritedOutfits: string[];
  onToggleFavourite: (id: string) => void;
}

export default function RecentTab({
  outfits,
  favouritedOutfits,
  onToggleFavourite,
}: RecentTabProps) {
  const recentOutfits = outfits.slice(0, 6);

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-2xl font-extralight tracking-[0.3em] uppercase text-gray-900 dark:text-white">
          RECENT CREATIONS
        </h2>
        <p className="mt-2 text-sm font-light tracking-wider text-gray-600 dark:text-gray-400">
          Your latest styling adventures
        </p>
      </div>
      
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {recentOutfits.map((outfit) => (
          <OutfitCard 
            key={outfit.id} 
            outfit={outfit} 
            onToggleFavourite={onToggleFavourite} 
            isFavourited={favouritedOutfits.includes(outfit.id)} 
          />
        ))}
      </div>
    </div>
  );
}